"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST API Detection Catalog
 * This schema defines the REST API endpoints for the detection catalog
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestFieldTypeToJSON = exports.SuggestFieldTypeFromJSONTyped = exports.SuggestFieldTypeFromJSON = exports.SuggestFieldType = void 0;
/**
 *
 * @export
 */
exports.SuggestFieldType = {
    Tag: 'tag',
    LogSource: 'logSource',
    ParserName: 'parserName',
    MitreId: 'mitreId'
};
function SuggestFieldTypeFromJSON(json) {
    return SuggestFieldTypeFromJSONTyped(json, false);
}
exports.SuggestFieldTypeFromJSON = SuggestFieldTypeFromJSON;
function SuggestFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SuggestFieldTypeFromJSONTyped = SuggestFieldTypeFromJSONTyped;
function SuggestFieldTypeToJSON(value) {
    return value;
}
exports.SuggestFieldTypeToJSON = SuggestFieldTypeToJSON;
